import BlogsComponent from '../components/blog-page/blogs-page'

const Blogs = () => <BlogsComponent />

export default Blogs;